<template>
  <div class="login">
    <div :class="['aside', bgImg ? 'aside' : 'aside-asset-bg']">
      <div class="leftback">
        <div class="toplogo">
          <i class="iconfont-ot-website icon-brand">&#xe603;</i>
          <!-- <div class="logo-txt">
            Offered by the OneASICS™ membership program.
          </div> -->
        </div>
      </div>
      <img :src="bgImg" alt="" />
    </div>
    <div class="rightback">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    bgImg() {
      if (this.$store.state.pageLeftImg) {
        return this.$store.state.pageLeftImg;
      }
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;

  .aside {
    background: #000;
    width: 50%;
    min-height: 100%;
    flex-shrink: 0;
    position: relative;
    .leftback {
      // background: url("../assets/imgs/account/shoe.jpg") no-repeat center center transparent;
      // background-size: cover;
      // text-align: center;
      // z-index: 10;
      // height: 100%;
      width: 100%;
      position: absolute;
      .toplogo {
        padding-top: 15px;
        padding-bottom: 5px;
        .icon-brand {
          font-size: 10rem;
          color: #212322;
          // padding-top: 46.7%;
        }
        .logo-txt {
          font-size: 1.2vw;
          padding: 0 25% 20px 25%;
          font-weight: 500;
          color: #fff;
        }
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .rightback {
    flex-grow: 1;
    padding: 20px;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 800px) {
  .login {
    display: block;
    .aside {
      background: #fff;
      width: 100%;
      .leftback {
        // background: 0 0 !important;
        height: 100%;
        width: 100%;
        .toplogo {
          .icon-brand {
            color: #212322;
            padding-top: 18.75%;
          }
          .logo-txt {
            font-size: 3.5vw;
            line-height: 1.2;
            color: #fff;
          }
        }
      }
    }
    .rightback {
      width: 90%;
      margin: 0 auto;
      padding: 20px 0;
    }
  }
}
</style>
